export enum RoleGroup {
  Company = 'Company',
  EazeeApp = 'EazeeApp'
}
